import Experience from './Experience'
import * as THREE from 'three'
import EventEmitter from './Utils/EventEmitter'

export default class Input extends EventEmitter
{
    constructor()
    {
        super()

        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.camera = this.experience.camera
        this.renderer = this.experience.renderer

        this.content = document.querySelector('.content')

        this.scrollY = 0
        this.mouseVector = new THREE.Vector2()
        
        this.mouseX = 0
        this.mouseY = 0
        
        this.isDragging = false
        this.startY = 0
        this.scrollStartY = 0
        

        this.setEventListeners()
    }

    setEventListeners()
    {
        if(this.content)
        {
            this.content.addEventListener('scroll', this.handleScroll.bind(this))
            this.content.addEventListener('mousedown', this.handleMouseDown.bind(this))

            // Add touch event listeners for mobile
            this.content.addEventListener('touchstart', this.handleTouchStart.bind(this))
        }
        
        window.addEventListener('mousemove', this.handleMouseMove.bind(this))
        window.addEventListener('mouseup', this.handleMouseUp.bind(this))

        // Add touch event listeners for mobile
        window.addEventListener('touchmove', this.handleTouchMove.bind(this))
        window.addEventListener('touchend', this.handleTouchEnd.bind(this))
    }

    handleScroll()
    {
        if(this.content)
        {
            this.scrollY = this.content.scrollTop
        }
        
    }

    handleMouseMove(event)
    {
        this.mouseX = (event.clientX/this.sizes.width - 0.5) * 2
        this.mouseY = ((event.clientY/this.sizes.height - 0.5) * 2) * -1

        this.mouseVector.x = this.mouseX
        this.mouseVector.y = this.mouseY

        if (this.isDragging && this.content) {
            const deltaY = event.clientY - this.startY
            if(Math.abs(deltaY) > 10) this.didScroll = true
            this.content.scrollTop = this.scrollStartY - deltaY * 4
        }
    }

    handleMouseDown(event)
    {
        this.isDragging = true
        this.didScroll = false
        this.startY = event.clientY

        this.trigger('mousedown')

        if(this.content)
        {
            this.scrollStartY = this.content.scrollTop
        }
    }

    handleMouseUp()
    {
        this.isDragging = false

        this.trigger('mouseup')
    }

    handleTouchStart(event)
    {
        this.isDragging = true
        this.didScroll = false
        this.startY = event.touches[0].clientY

        // Update mouseVector from touch position so raycasting works on mobile
        this.mouseVector.x = (event.touches[0].clientX / this.sizes.width - 0.5) * 2
        this.mouseVector.y = ((event.touches[0].clientY / this.sizes.height - 0.5) * 2) * -1

        this.trigger('mousedown')

        if(this.content)
        {
            this.scrollStartY = this.content.scrollTop
        }
    }

    handleTouchMove(event)
    {
        if (this.isDragging && this.content) {
            const deltaY = event.touches[0].clientY - this.startY
            if(Math.abs(deltaY) > 10) this.didScroll = true
            this.content.scrollTop = this.scrollStartY - deltaY * 1.5
        }
    }

    handleTouchEnd()
    {
        this.isDragging = false
        this.trigger('mouseup')
    }
    
}